import { createFileRoute } from '@tanstack/react-router';
import EmergencyMode from '~/containers/EmergencyMode';

export const Route = createFileRoute('/emergency-mode')({
  component: EmergencyMode,
});
